import ApiService from '../../../../../../services/ApiService'
import Utils from '../../../../../../Utils/FormatDate'

export default {
  props: {
    filterProp: Object,
  },
  components: {},

  data() {
    return {
      apiService: new ApiService(),
      loading: false,
      showChart: true,
      downtimes: [],
      expanded: [],
      page: 1,
      totalPages: 1,
      pageSize: 7,
      headerProps: {
        sortByText: 'Ordenar por',
      },
      downtimeHeader: [
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'Equipamento Padrão',
          align: 'center',
          value: 'standardEquipment',
        },
        {
          text: 'Identificação',
          align: 'center',
          value: 'identification',
        },
        {
          text: 'Fabricante',
          align: 'center',
          value: 'manufacturer',
        },
        {
          text: 'Nº O.S.',
          align: 'center',
          value: 'serviceOrderNumber',
        },
        {
          text: 'Modelo',
          align: 'center',
          value: 'model',
        },
        {
          text: 'Data de Parada',
          align: 'center',
          value: 'stopDate',
        },
        {
          text: 'Data de Retorno',
          align: 'center',
          value: 'returnDate',
        },
        {
          text: 'Tempo Parado (hora)',
          align: 'center',
          value: 'totalDowntime',
        },
      ],
      downtimeMobileHeader: [
        {
          text: 'Equipamento Padrão',
          align: 'center',
          value: 'standardEquipment',
        },
        {
          text: 'Tempo Parado (hora)',
          align: 'center',
          value: 'totalDowntime',
        },
      ],
      total: 0,
    }
  },
  async created() {
    this.listDowntimes()
  },
  methods: {
    requestExcel() {
      this.filterProp.pageSize = 10000
      let now = new Date()
      var filename = `Equipment_Dowmtime_${now.getDate()}-${
        now.getMonth() + 1
      }-${now.getFullYear()}.xlsx`
      this.apiService
        .post('excel/equipmentDowmtime', this.filterProp)
        .then((response) => {
          response = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = response
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
    },
    async listDowntimes() {
      await this.apiService
        .post('reports/machineDowntime', this.filterProp)
        .then((response) => {
          this.showChart = response.content.objects.length > 0
          this.downtimes = response.content.objects
          this.totalPages = response.content.pager.totalPages
          this.total = response.content.pager.totalItems
        })
    },

    formatDate(date) {
      return Utils.dateTime(date)
    },
  },
  watch: {
    page() {
      this.filterProp.page = this.page
      this.listDowntimes()
    },
  },
}
